import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';

import { handleExportGeneric } from '~/helpers/exportReports';

import {
  deleteConversorEntradaSaida,
  findConversorEntradaSaida,
  recordFiltering,
} from '~/store/modules/conversorEntradaSaida/actions';

import Form from './form';

function ConversorEntradaSaidaList() {
  const redux = useSelector((state) => state.conversorEntradaSaida);

  const header = useMemo(
    () => [
      {
        id: 'nomeposto',
        label: t('s.configuracao.terminal.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'idposto',
        label: t('s.configuracao.tanquefisico.idposto'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeconversor',
        label: t('s.geral.camposistema.nomemodeloveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'ipconversor',
        label: t('s.configuracao.terminal.ipterminal'),
        filter: { type: 'text' },
      },
      {
        id: 'portaconversor',
        label: t('s.configuracao.terminal.portaterminal'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const fieldlist = [
    'nomeconversor',
    'idposto',
    'nomeposto',
    'ipconversor',
    'portaconversor',
  ];

  const substituirHeader = {
    nomeposto: t('s.configuracao.terminal.nomeposto'),
    idposto: t('s.configuracao.tanquefisico.idposto'),
    nomeconversor: t('s.geral.camposistema.nomemodeloveiculo'),
    idconversor: t('s.operacao.limpezatag.possuidvecveiculostr'),
    portaconversor: t('s.configuracao.terminal.portaterminal'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findConversorEntradaSaida}
      remove={deleteConversorEntradaSaida}
      form={Form}
      keys="idconversor"
      detach="nomeposto"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'conversores',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Conversores',
        })
      }
    />
  );
}

export default ConversorEntradaSaidaList;
